import { Search } from "lucide-react";
import { Button, FieldHint, FieldLabel, TextInput } from "@amber/ui";
import { CandidateList } from "./CandidateList";
import type { CreateFlow } from "./useCreateProfile";

export function FindStep({ flow }: { flow: CreateFlow }) {
  return (
    <>
      <FieldLabel htmlFor="profile-find" required>
        Name
      </FieldLabel>
      <div className="flex gap-2">
        <TextInput
          id="profile-find"
          placeholder="Type a name, or paste a Wikipedia link"
          value={flow.text}
          onChange={(e) => {
            flow.setText(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              flow.find();
            }
          }}
        />
        <Button
          size="md"
          onClick={flow.find}
          disabledReason={flow.text.trim().length === 0 ? "Type a name first" : null}
        >
          <Search size={13} aria-hidden="true" /> Find
        </Button>
      </div>
      <FieldHint>
        Candidates come from Wikipedia and Wikidata, in any language. A Wikipedia link is looked up directly; redirects,
        mobile links and other editions resolve to one identity.
      </FieldHint>
      <CandidateList
        query={flow.query}
        onChoose={flow.choose}
        onManual={() => {
          flow.setStep({ kind: "manual" });
          flow.setDisplayName(flow.query.startsWith("http") ? "" : flow.query);
          flow.setLanguages([]);
          flow.setDifferent([]);
        }}
      />
    </>
  );
}
